module.exports = __webpack_public_path__ + "img/insert-04-droit.bd4fb787.svg";